<template>
    <label class="switch">
        <input
            type="checkbox"
            :checked="modelValue"
            @input="updateValue"
        >
        <span
            class="slider"
            :class="{left: modelValue, right: !modelValue}"
        >{{ modelValue ? enabledText: disabledText }}</span>
    </label>
</template>
<script setup lang="ts">
import { defineProps, defineEmits } from 'vue';
const emit = defineEmits(['update:modelValue']);
defineProps({ modelValue: Boolean });

// TODO: replace these with props and resize the component dynamically
const enabledText = 'Enabled';
const disabledText = 'Disabled';

function updateValue(event: Event) {
    const target = <HTMLInputElement>event.target;
    emit('update:modelValue', target.checked);
}

</script>
<style lang="scss">
.switch {
    position: relative;
    display: inline-block;
    width: 105px;
    height: 34px;

    input {
        opacity: 0;
        width: 0;
        height: 0;
    }

    input:checked + .slider {
        background-color: var(--color-playvox-green-60);
    }

    input:focus + .slider {
        box-shadow: 0 0 1px var(--color-playvox-green-60);;
    }

    input:checked + .slider:before {
        -webkit-transform: translateX(76px);
        -ms-transform: translateX(76px);
        transform: translateX(70px);
    }

    .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: var(--color-eerie-black-50);
        -webkit-transition: .4s;
        transition: .4s;
        display: inline-flex;
        align-items: center;
        color: var(--color-text--10);
        border-radius: 34px;
        padding-right: 10px;
        padding-left: 10px;

        &.right{
            justify-content: right;
        }
        &.left {
            justify-content: left;
        }
    }

    .slider:before {
        position: absolute;
        content: "";
        height: 26px;
        width: 26px;
        left: 4px;
        bottom: 4px;
        background-color: var(--color-white);
        -webkit-transition: .4s;
        transition: .4s;
        border-radius: 50%;
    }
}
</style>